import { analyticsService } from "@core/service-container";
import { AnalyticsCategory } from "@domain/analytics/analytics-types";
import { ProgramDetails } from "@domain/program/program";
import { ProgramDays } from "@domain/program/program-days";

export enum AnalyticsTemplateLocation {
	TEMPLATE_TOP = "templateTop",
	TEMPLATE_BOTTOM = "templateBottom",
	PATIENT_CREATION = "patientCreation",
}
enum AnalyticsTemplateClickType {
	TEMPLATE_LIST_DETAIL = "templateListDetail",
	TEMPLATE_LIST_CLICK = "templateListClick",
}

export const sendAnalyticsEventViewTemplateList = (): void =>
	analyticsService.trackEvent({ category: AnalyticsCategory.TEMPLATE, action: "viewTemplateList" });

export const sendAnalyticsEventViewTemplate = (templateId: string, fromCardActions?: boolean): void =>
	analyticsService.trackEvent({
		category: AnalyticsCategory.TEMPLATE,
		action: "viewTemplate",
		params: [
			templateId,
			fromCardActions
				? AnalyticsTemplateClickType.TEMPLATE_LIST_DETAIL
				: AnalyticsTemplateClickType.TEMPLATE_LIST_CLICK,
		],
	});

export const sendAnalyticsEventCreateTemplate = (location: AnalyticsTemplateLocation): void =>
	analyticsService.trackEvent({
		category: AnalyticsCategory.TEMPLATE,
		action: "createTemplate",
		params: [location],
	});

export const sendAnalyticsEventSaveTemplate = (templateId: string): void =>
	analyticsService.trackEvent({
		category: AnalyticsCategory.TEMPLATE,
		action: "saveTemplate",
		params: [templateId],
	});

export const sendAnalyticsEventEditTemplate = (templateId: string): void =>
	analyticsService.trackEvent({
		category: AnalyticsCategory.TEMPLATE,
		action: "editTemplate",
		params: [templateId],
	});

export const sendAnalyticsEventDeleteTemplate = (templateId: string): void =>
	analyticsService.trackEvent({
		category: AnalyticsCategory.TEMPLATE,
		action: "deleteTemplate",
		params: ["templateList", templateId],
	});

export const sendAnalyticsEventAssignProgram = (
	analyticsId: string,
	programId: string,
	days: ProgramDays,
	exerciseDetails: ProgramDetails,
): void =>
	analyticsService.trackEvent({
		category: AnalyticsCategory.TEMPLATE,
		action: "assignProgram",
		params: [
			analyticsId,
			programId,
			days.sessionsPerWeek,
			days.exercisesPerWeek,
			exerciseDetails.exerciseTitles.join(";"),
			exerciseDetails.exerciseUnits.join(";"),
			exerciseDetails.exerciseSets.join(";"),
			exerciseDetails.exerciseIds.join(";"),
			exerciseDetails.exerciseRevisions.join(";"),
			exerciseDetails.exerciseCategories.join(";"),
			exerciseDetails.exerciseBodyParts.join(";"),
			exerciseDetails.exerciseDifficulties.join(";"),
			exerciseDetails.exerciseStartingPosition.join(";"),
		],
	});
